import AsyncSelect from 'react-select/async'
import { FormSelectProps } from '../../../models'

/**
 * Wrapper sobre react-select/async (autocomplete remoto).
 * Renderiza label + AsyncSelect + mensaje de error desde react-hook-form.
 * Usa `cargaOpciones` (funcion async) para buscar opciones en backend.
 */
export const FormSelectAutocomplete = <TFormValues extends Record<string, unknown>>({
  elementos,
  placeholder,
  onChange,
  nombre,
  defaultValue,
  className,
  isObligatorio,
  Componente,
  value,
  errors,
  isClearable = true,
  isSearchable = true,
  nombreCampo,
  cargaOpciones,
  inputChange,
  autoFocus,
  isDisabled,
}: FormSelectProps<TFormValues>) => {
  return (
    <div className={className}>
      {nombre && (
        <label className='form-label fs-4'>
          {nombre} {isObligatorio && <span className='text-danger'>*</span>}
        </label>
      )}
      <AsyncSelect
        autoFocus={autoFocus}
        isDisabled={isDisabled}
        loadingMessage={() => 'Recuperando'}
        key={`_${value}`}
        styles={customStyles}
        loadOptions={cargaOpciones}
        aria-label={nombre}
        className='form-select-autocomplete'
        isClearable={isClearable}
        defaultValue={defaultValue}
        onChange={onChange}
        getOptionLabel={(option) => option.etiqueta}
        getOptionValue={(option) => option.valor}
        placeholder={placeholder}
        menuPosition='fixed'
        noOptionsMessage={() => 'No se encontraron coincidencias'}
        components={{ Option: Componente || Opcion }}
        value={value}
        isSearchable={isSearchable}
        required={isObligatorio}
        onInputChange={inputChange}
      />
      {errors && errors[nombreCampo] && (
        <p className='text-danger text-end fs-5'>{errors[nombreCampo]?.message}</p>
      )}
    </div>
  )
}

const Opcion = (props: any) => {
  const { innerProps, innerRef, isSelected, isFocused } = props
  return (
    <div
      ref={innerRef}
      {...innerProps}
      className='custom-select p-3'
      style={{
        backgroundColor: isSelected ? '#ffd5c4' : isFocused ? '#ffe7e2' : '#f5f8fa',
      }}>
      <p>{props.data.etiqueta}</p>
    </div>
  )
}

const padding = '0 !important'

const customStyles = {
  menu: (provided: any) => ({
    ...provided,
    marginTop: '.2rem',
    paddingTop: padding,
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    paddingRight: padding,
  }),
  menuList: (provided: any) => ({
    ...provided,
    padding: padding,
  }),
  control: (provided: any) => ({
    ...provided,
    border: '1px solid #f5f8fa',
    backgroundColor: '#f5f8fa',
    padding: '.2rem 0',
    transition: 'all .5s ease',
    boxShadow: 'none',
    '&:hover': {
      border: '1px solid #ffc1a8',
    },
  }),
  singleValue: (provided: any) => {
    return { ...provided, padding: '0 .2rem', color: '#5E6278' }
  },
  indicatorsContainer: (provided: any) => ({
    ...provided,
    padding: padding,
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    color: '#5E6278',
    backgroundColor: state.isSelected ? '#ffd5c4' : '#f5f8fa',
    fontFamily: 'TheSans',
    '&:hover': {
      backgroundColor: '#ffe7e2',
    },
  }),
  placeholder: (provided: any) => {
    return {
      ...provided,
      color: '#A1A5B7',
    }
  },
}
